/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { EVENT_NAMES, track } from '@zcode/mixpanel'
import type { Listable, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import type { GetState } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'
import type { PageName } from '../helpers/types'

export const mixpanelFavorite =
  ({
    pageName,
    entity,
  }: {
    entity: Listable | Pin<RawPinInventorySearch> | Property
    pageName: PageName | undefined
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const payload = getCommonProps({ state, pageName, entity })

    track({ event: EVENT_NAMES.FAVORITE, payload: { ...payload } })
  }
